<template>
  <v-container fluid tag="section">
    <v-row>
      <v-col cols="12" md="6">
        <base-material-card
          color="success"
          inline
          comment-icon="mdi-email"
          title="Register email content"
          class="px-5 py-3"
        >
          <v-form class="mt-5">
            <v-text-field
              v-model="item.title"
              :label="$t('subject')"
              outlined
            />

            <v-text-field
              v-model="item.writer"
              :label="$t('writer')"
              outlined
            />

            <v-textarea
              v-model="item.content"
              :label="$t('content')"
              outlined
            />

            <v-checkbox label="Test send" class="mt-0" />
          </v-form>

          <v-card-actions class="pl-0">
            <v-btn color="success" min-width="100" @click="submitStore"
              >{{ $t("save") }}
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" top centered>
      {{ notificationMessage }}
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    urlIndex: "/contents/contents-email",

    item: {
      title: "",
      writer: "",
      content: "",
    },

    snackbar: false,
    notificationMessage: "",
  }),
  methods: {
    async submitStore() {
      try {
        const formData = {
          title: this.item.title,
          writer: this.item.writer,
          content: this.item.content,
        };
        console.log("before stored,", typeof formData, formData);
        const res = await this.authPost(
          "/api/contents/contents-email/store",
          formData
        );
        console.log("after stored,", res);
        if (res.data.result) {
          // this.showNotification("Registered");
          location.href = this.urlIndex;
        }
      } catch (e) {
        console.error(e);
      }
    },

    showNotification(msg) {
      this.notificationMessage = msg;
      this.snackbar = true;
    },
  },
};
</script>
